import { A365Named } from '../base/a365Named';
import { IModel } from '../base/annotation';
import { Metamodel } from '../base/model';
import { AttributeMapping } from './attributemapping';
import { AttributeReference } from './attributereference';

export interface IDenormalizeInfo {
    entities: IDenormalizeEntity[];
}

export interface IDenormalizeEntity {
    joinPairs: IMappingJoinPair[];
    toEntity: string;
}

export interface IMappingJoinPair {
    fromAttribute: AttributeReference;
    toAttribute: string;
    operator?: string;
    expression?: string;
}

@Metamodel.model({
    name: 'mappingdirective',
    display: ['mappingdirective', 'mappingdirectives'],
    reusable: true,
    referable: true
})
export class MappingDirective extends A365Named {
    public static readonly MODEL: IModel;

    public targetEntityReference: AttributeReference;
    public sourceEntityReferences: AttributeReference[];
    public sourceDenormalizeInfo?: IDenormalizeInfo;
    public attributeMappingInfo: AttributeMapping[];

    constructor(name: string = '') {
        super(name);
        this.name = name;
        this.attributeMappingInfo = [];
        this.sourceDenormalizeInfo = {
            entities: []
        };
    }

    public addAttributeMapping(attributeMapping: AttributeMapping): AttributeMapping {
        this.attributeMappingInfo.push(attributeMapping);
        return attributeMapping;
    }

    public removeAttributeMapping(name: string): void {
        this.attributeMappingInfo = this.attributeMappingInfo.filter((item) => item.name !== name);
    }

    public removeAttributeMappingByIndex(index: number): void {
        this.attributeMappingInfo.splice(index, 1);
    }

    public addSourceDenormalizeEntity(entity: IDenormalizeEntity): void {
        this.sourceDenormalizeInfo.entities.push(entity);
    }

    public removeSourceDenormalizeEntity(entityName: string): void {
        this.sourceDenormalizeInfo.entities.filter((item) => item.toEntity !== entityName);
    }

    public getTargetColumnsFromMappings(): string[] {
        if (!this.attributeMappingInfo || this.attributeMappingInfo.length === 0) {
            return [];
        }

        return this.attributeMappingInfo.map((am) => am.name);
    }
}
